interface Item {
    name?: string | null;
}

export default function sortByName(a: Item, b: Item): number {
    const nameA = a.name || '';
    const nameB = b.name || '';
    return nameA.localeCompare(nameB);
}
